// extracted by mini-css-extract-plugin
export default {"activeTab":"Tabs_activeTab__iFURl","defaultTab":"Tabs_defaultTab__vhX-w","tabContent":"Tabs_tabContent__sHv-t"};